<scf-common-form
  title="tariffs.leasing.title"
  [isSectorDisplayed]="true"
  [isTariffDisplayed]="true"
  [commercialProduct]="'40'"
  (sendForm)="getLeasingAuto($event)"
></scf-common-form>

<scf-common-table
  *ngIf="isTariffSheetValid()"
  [tariffRequest]="tariffSheetRequest"
  [tariffResponse]="tariffSheetResponse"
></scf-common-table>

<div *ngIf="isTariffSheetValid()" class="panel_footer__buttons">
  <button id="btnExportExcel" mat-stroked-button color="accent" (click)="createExcel()">
    <mat-icon class="icon-ic_file_download"></mat-icon>
    <span>{{ 'request.button.excel' | translate | uppercase }}</span>
  </button>
  <button id="btnPrintPDF" mat-stroked-button color="accent" (click)="createPdf()">
    <mat-icon class="icon-ic_print"></mat-icon>
    <span>{{ 'request.button.print' | translate | uppercase }}</span>
  </button>
</div>
